import { Magnifier } from 'app/design/icons/magnifier';
import { Box } from 'app/design/primitives/box';
import { Button } from 'app/design/primitives/button';
import { Text } from 'app/design/primitives/text';

import { useUISize } from 'app/utils/web-helpers';
import { createTheme as createDSTheme } from 'app/shopify';
import type { Theme } from 'app/shopify';
const theme = createDSTheme();

interface FavouritesEmptyStateProps {
  title: string;
  subtitle: string;
  buttonText: string;
  onExplore: () => void;
  backgroundColor?: keyof Theme['colors'];
}

export function FavouritesEmptyState({
  title,
  subtitle,
  buttonText,
  onExplore,
  backgroundColor,
}: FavouritesEmptyStateProps) {
  const { isSmallUI } = useUISize();
  return (
    <Box
      alignItems="center"
      backgroundColor={backgroundColor}
      borderColor="surface.inverse.tertiary-neutral"
      borderRadius="radius.md"
      borderWidth={isSmallUI ? 0 : 1}
      gap="spacing.general.x4"
      paddingHorizontal="spacing.general.x8"
      paddingVertical="spacing.general.x4"
    >
      <Text style={{ fontSize: 52 }}>❤️</Text>
      <Text fontWeight="700" textAlign="center" variant="bodyLarge">
        {title}
      </Text>
      <Text color="text.secondary" textAlign="center" variant="bodyBase">
        {subtitle}
      </Text>
      <Button
        alignSelf={isSmallUI ? 'stretch' : 'center'}
        marginTop="spacing.general.x2"
        onPress={onExplore}
        prefix={<Magnifier color="white" />}
        style={{ borderRadius: theme.borderRadii['radius.full'] }}
        variant="primary"
      >
        <Text textAlign="center" variant="bodyBase" fontWeight="600" color="white">
          {buttonText}
        </Text>
      </Button>
    </Box>
  );
}
